/**
 *  TODO 关注信息
 */

import React, {Component} from 'react';
import { ImageView } from 'c-up-ui';
import TimeUtil from 'c-up-time';
import Url from 'c-url';
import global from '../base/global';
import lang from '../lang';
import Follow from '../component/follow';
import Profile from "../component/profile/index";
import notification from 'c-notification';
import Cache from 'c-cache';

let cache = new Cache({
    prefix: 'uplive'
});

class UserInfo extends Component {
	static defaultProps = {
		dynamicInfo: { } // 用户信息
	}

	constructor(props){
		super(props);

		let data = this.props.dynamicInfo;
		let { userInfo } = data;

		this.state = {
			followType: 0
		}
	}

	componentWillMount(){
		let { userInfo } = this.props.dynamicInfo;
		let uid = longToString(userInfo.uid);
		
		this.getProfileByUserId(uid);
	}

	getProfileByUserId(uid) {

        let getUserProfileCount = 0; // 请求失败，则请重新求。重试三次

        let getUserProfile = (uid)=>{

            let promise = new Profile(uid).promise;
            
            promise.done((data) => {
                // 当前用户登录信息
                this.setState({
                	userInfo: data,
                	followType: [1, 3].indexOf(data.followType) >= 0 ? 1 : 0
                });                   
            }).fail(() => {
                
                ++getUserProfileCount;

                if (getUserProfileCount > 3) {

                    notification.simple(lang.template('获取用户信息失败, 请稍后再试'), 100000);
                } else {
                    getUserProfile(uid);
                }
            });
        }
        
        getUserProfile(uid);
    }

	handleClick=()=>{
		$.channel.emit('download');
	}

	goProfile=(uid)=>{
		 global.goUpliveProfile(uid);
	}

	onClickTopic(topicId) {
		let _url = Url.delQuery(location.href, 'dynamicId');

        _url = Url.delQuery(_url, 'rid');
        _url = Url.delQuery(_url, 'shareType');

        _url = Url.addParam(_url, {
            dynamicId: longToString(topicId)
        });

        _url = Url.addParam(_url, {
            rid: longToString(topicId)
        });
        
        _url = Url.addParam(_url, {
            shareType: 2
        });

        location.href = _url;
	}

	render() {
		let data = this.props.dynamicInfo;

		let { userInfo, createTime, commentNum, likeNum, shareNum , content} = data;
		let uid = longToString(userInfo.uid);
		let time = TimeUtil.formatDate(createTime * 1000, lang.template('MM月dd日'));
		
        let followType;
        let followed = this.state.followType;
        let temp = {};
        let $btn = null;

		if (uid != global.getUser().uid) {
            // 1 关注 2 被关注 3相互关注
            if (followed) { 
                followType = 'followed';
            }
            $btn = (
                <span 
                    onClick={()=>{
                        if (followed) {
                            temp.follow.unFollow(userInfo.uid);
                        } else {
                        	if (!cache.getCache('isRegisterRealUser')) {
                        		$.channel.emit('download');
                        		return;
                        	}
                            temp.follow.do(userInfo.uid);
                        }
                    }} 
                    className="btn" 
                    data-show={followType}>
                </span>
            );

            if ($btn) {
                temp.follow = new Follow();
                temp.follow.on('followSuccess', ()=>{
                	this.setState({
                		followType: 1
                	});
                });
                temp.follow.on('unFollowSuccess', ()=>{
                    this.setState({
                		followType: 0
                	});
                });
            }
        }

		return (
			<div className="user-wrapper">
				<div className="user-info">
					<div className="avatar" onClick={this.goProfile.bind(this, userInfo.uid)}>
						<ImageView size={32} src={userInfo.avatar} circle/>
					</div>
					<div className="info">
						<div className="username">{ userInfo.userName}</div>
						<div className="createtime">{ time }</div>
					</div>
					{ $btn }
				</div>
				{
					data.topicName ? <div className="topicname" onClick={this.onClickTopic.bind(this, data.topicId)}><em>{`#${data.topicName}#`}</em></div> : null
				}
				<div className="content">
					{ content.text }
				</div>
				<ul className="feed-count">
					<li className="like" onClick={this.handleClick}>
						<i></i>
						<em>{ likeNum || 0 }</em>
					</li>
					<li className="comment" onClick={this.handleClick}>
						<i></i>
						<em>{ commentNum || 0 }</em>
					</li>
					<li className="share" onClick={this.handleClick}>
						<i></i>
						<em>{ shareNum || 0 }</em>
					</li>
				</ul>
			</div>
		);
	}
}
export default UserInfo;


// WEBPACK FOOTER //
// ./js/feedshare/userinfo.js